module.exports = __webpack_public_path__ + "media/images/bg/headers/video-course-70189b9bdaa3eed3af3eb14f2adc7406.svg";